export const HEADER_HEIGHT = 60;
export const SIDEBAR_WIDTH = 260;
export const COLLAPSED_SIDEBAR_WIDTH = 86;
export const SIDEBAR_TOP_HEADER_AREA = 70;

export const ROUTES = { HOME: '/', REPOS: '/repos', SIGNIN: '/signin' };
